import { render, staticRenderFns } from "./IqpDialogMessage.vue?vue&type=template&id=58f5b8a1&scoped=true"
import script from "./IqpDialogMessage.vue?vue&type=script&lang=js"
export * from "./IqpDialogMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f5b8a1",
  null
  
)

export default component.exports